import DashboardLayout from "../../../../Layouts/DashboardLayout";
import ContentBodyWrapper from "../../../../Layouts/Containers/ContentBodyWrapper";
import ContentBodyHeader from "../../../../Layouts/Containers/ContentBodyHeader";
import reactRouteList from "../../../../config/react-route-list-config";
import { useParams } from "react-router-dom";
import EditUserForm from "../../../../components/Forms/EditUserForm";
import { useTranslation } from "react-i18next";
import { changeBrowserTabTitle } from "../../../../utils/Browser";
import ButtonBlack from "../../../../components/Buttons/ButtonBlack";

export default function UserEditPage() {
    let { id } = useParams();
    const [t] = useTranslation();
    changeBrowserTabTitle("Edit User");
    const breadCrumbLink =
        reactRouteList.loggedRoutes.edit_user.link + "/" + id;
    const breadCrumbitem = id;

    const buttons = (
        <ButtonBlack
            to={reactRouteList.loggedRoutes.user_list}
            icon={"material-symbols:arrow-back"}
        >
            {t("Back")}
        </ButtonBlack>
    );

    return (
        <>
            <DashboardLayout>
                <ContentBodyWrapper showFooter={true}>
                    <ContentBodyHeader
                        info={{
                            title: t("Edit User"),
                        }}
                        breadcrumb={[
                            {
                                linkitem: t("Users"),
                                link: reactRouteList.loggedRoutes.user_list,
                            },
                            {
                                linkitem: t("Edit"),
                                link: breadCrumbLink,
                            },
                            { linkitem: breadCrumbitem, link: breadCrumbLink },
                        ]}
                        buttons={buttons}
                    />
                    <EditUserForm id={id} />
                </ContentBodyWrapper>
            </DashboardLayout>
        </>
    );
}
